import { Toast } from 'antd-mobile';
import * as services from '../services';

export default {
  namespace: 'memberShipCenter',
  state: {
    containerList: [],
    myMemRewardsList: [],
    myRawardDetail: {},
    rewardHistoryList: [],
    rewardHistoryTotalCount: 0,
    rewardHistoryPageIndex: 1,
    rewardHistoryActiveTab: 'G',
    rewardDetail: {},
    pinLength: 6,
  },
  effects: {
    *qryCmsPageDetail({ payload }, { put, call }) {
      const res = yield call(services.qryCmsPageDetail, payload);
      const { data, resultMsg } = res || {};
      // console.log('qryCmsPageDetail 1', data);
      const { containerList = [] } = data || {};
      // console.log('qryCmsPageDetail 2', containerList);
      yield put({
        type: 'save',
        payload: {
          containerList,
        },
      });
      if (resultMsg) {
        Toast.show({ icon: 'fail', content: resultMsg });
      }
      return containerList;
    },
    // *getUserBadgeInfo({ payload }, { call }) {
    //   const response = yield call(services.getUserBadgeInfo, payload);
    //   return response;
    //   // return fd.medalData || response;
    // },
    // *qryUserRewardDetail({ payload }, { call }) {
    //   try {
    //     const resp = yield call(services.qryUserRewardDetail, payload);
    //     // const { data } = fd.rewardDetail;
    //     // const code = '0';
    //     const data = get(resp, 'data');
    //     const code = get(resp, 'retCode');
    //     const retDesc = get(resp, 'retDesc');
    //     // 0表示成功
    //     if (code === '0') {
    //       return data || {};
    //     }
    //     Toast.fail(retDesc);
    //     return {};
    //   } catch (e) {
    //     Toast.fail(e.Error);
    //     return {};
    //   }
    // },
    *qryUserMMSInfoDXP({ payload }, { call }) {
      let response = yield call(services.qryUserMMSInfoDXP, payload);
      response = {
        ...response,
        retCode: response.resultCode,
        retDesc: response.resultMsg,
        data: {
          ...(response.data || {}),
          membershipTypeId: response.data.membershipTypeCode,
        },
      };
      return response;
      // return fd.medalData || response;
    },
    *qryUserMMSInfo({ payload }, { call }) {
      const response = yield call(services.qryUserMMSInfo, payload);
      return response;
      // return fd.medalData || response;
    },
    *qryMMSTypeInfo({ payload }, { call }) {
      const response = yield call(services.qryMMSTypeInfo, payload);
      return response;
      // return fd.medalData || response;
    },
    *qryMMSTypeInfoDXP({ payload }, { call }) {
      let response = yield call(services.qryMMSTypeInfoDXP, payload);
      response = {
        ...response,
        retCode: response.resultCode,
        retDesc: response.resultMsg,
        data: {
          ...(response.data || {}),
          membershipLevelList: (response?.data?.membershipLevelList || []).map(item => ({
            ...item,
            growthValue: item.growthValueInt,
            growthValueDisplay: item.growthValue,
            membershipLevelBenefitList: item.membershipLevelBenefitList?.map(benefitItem => ({
              ...benefitItem,
              mmsLevelBenefitRewardList: benefitItem.rewardList?.map(rewardItem => ({
                ...rewardItem,
                isManualReceive: rewardItem.isManualReceive ? 'Y' : 'N',
              })),
            })),
          })),
        },
      };
      // response.data.membershipLevelList.membershipLevelBenefitList.mmsLevelBenefitRewardList =
      //   response?.data?.membershipLevelList?.membershipLevelBenefitList?;
      return response;
      // return fd.medalData || response;
    },
    *qryUpgradeMethod({ payload }, { call }) {
      const response = yield call(services.qryUpgradeMethod, payload);
      return response;
      // return fd.medalData || response;
    },
    *qryUpgradeMethodDXP({ payload }, { call }) {
      let response = yield call(services.qryUpgradeMethodDXP, payload);
      response = {
        ...response,
        retCode: response.resultCode,
        retDesc: response.resultMsg,
        data: {
          mmsUpgradeRecomList: {
            ...(response.data || {}),
            upgradeMethod: response?.data?.upgradeType,
            upgradeMethodName: response?.data?.upgradeTypeName,
            mmsUpgradeRecomDetailList: (response?.data?.methodList || [])?.map(item => ({
              ...item,
              recomDetailKey: item.method,
              recomDetailName: item.methodName,
            })),
          },
        },
      };
      return response;
      // return fd.medalData || response;
    },
    *qryUpgradeGuidUrl({ payload }, { call }) {
      const response = yield call(services.qryUpgradeGuidUrl, payload);
      return response;
    },
    *qryUserRewardList({ payload }, { call }) {
      const response = yield call(services.qryUserRewardList, payload);
      return response;
      // return fd.medalData || response;
    },
    *qryUserRewardListDXP({ payload }, { call }) {
      let response = yield call(services.qryUserRewardListDXP, payload);
      response = {
        ...response,
        retCode: response.resultCode,
        retDesc: response.resultMsg,
        data: {
          rewardList: response?.data?.map(item => ({
            ...item,
            orderId: item.orderNbr,
            prcResSn: item.couponSn,
            prcResPwd: item.couponPwd,
            prcResExpDate: item.expDate,
            couponId: item.couponSn,
            telcoFlag: item.isTelco ? 'Y' : 'N',
            participated: item.participatedNbr,
            sendMethod: item.physicalRewardClaimMethod,
            receiveDeadDate: item.deadLine,
            keyId: item.rewardInstanceId,
          })),
        },
      };
      return response;
      // return fd.medalData || response;
    },
    *qryUserRewardDetail({ payload }, { call }) {
      const response = yield call(services.qryUserRewardDetail, payload);
      return response;
      // return fd.medalData || response;
    },
    *qryUserRewardDetailDXP({ payload }, { call }) {
      let response = yield call(services.qryUserRewardDetailDXP, payload);
      const item = response.data || {};
      response = {
        ...response,
        retCode: response.resultCode,
        retDesc: response.resultMsg,
        data: {
          ...item,
          orderId: item.orderNbr,
          prcResSn: item.couponSn,
          prcResPwd: item.couponPwd,
          prcResExpDate: item.expDate,
          couponId: item.couponSn,
          telcoFlag: item.isTelco ? 'Y' : 'N',
          participated: item.participatedNbr,
          sendMethod: item.physicalRewardClaimMethod,
          receiveDeadDate: item.deadLine,
        },
      };
      return response;
      // return fd.medalData || response;
    },
    *claminMemReward({ payload }, { call }) {
      const response = yield call(services.claminMemReward, payload);
      return response;
      // return fd.medalData || response;
    },
    *claminMemRewardDXP({ payload }, { call }) {
      let response = yield call(services.claminMemRewardDXP, payload);
      response = {
        ...response,
        retCode: response.resultCode,
        retDesc: response.resultMsg,
        data: response.data,
      };
      return response;
      // return fd.medalData || response;
    },
    *queryPinFormat(_, { put, call }) {
      try {
        const response = yield call(services.getPinFormat);
        if (response && response.resultCode === '0' && response.data) {
          yield put({
            type: 'save',
            payload: { pinLength: response.data.pinLength || 6 },
          });
        }
      } catch {
        // use default 6
      }
    },
    *queryRewardDetail({ payload }, { put, call }) {
      try {
        const response = yield call(services.getRewardDetail, payload.rewardInstanceId);
        if (response && response.resultCode === '0') {
          yield put({
            type: 'save',
            payload: { rewardDetail: response.data || {} },
          });
          return response;
        }
        Toast.show({ icon: 'fail', content: response?.resultMsg || 'Failed' });
        return null;
      } catch (error) {
        Toast.show({ icon: 'fail', content: error.message || 'Error' });
        return null;
      }
    },
    *queryBenefitRewardDetail({ payload }, { put, call }) {
      try {
        const response = yield call(services.getBenefitRewardDetail, payload.benefitRewardId);
        if (response && response.resultCode === '0') {
          yield put({
            type: 'save',
            payload: { rewardDetail: response.data || {} },
          });
          return response;
        }
        Toast.show({ icon: 'fail', content: response?.resultMsg || 'Failed' });
        return null;
      } catch (error) {
        Toast.show({ icon: 'fail', content: error.message || 'Error' });
        return null;
      }
    },
    *claimRewardInstance({ payload }, { call }) {
      try {
        const response = yield call(services.claimReward, payload);
        return response;
      } catch (error) {
        Toast.show({ icon: 'fail', content: error.message || 'Error' });
        return null;
      }
    },
    *useRewardInstance({ payload }, { call }) {
      try {
        const response = yield call(services.useReward, payload);
        return response;
      } catch (error) {
        Toast.show({ icon: 'fail', content: error.message || 'Error' });
        return null;
      }
    },
    *queryRewardHistory({ payload }, { put, call, select }) {
      try {
        const response = yield call(services.getRewardHistory, payload);
        const { resultMsg } = response;
        if (response && response.resultCode === '0') {
          const { rewardHistoryList: currentList } = yield select(state => state.memberShipCenter);
          const data = response.data || [];
          const newList = payload.pageIndex === 1 ? data : [...currentList, ...data];
          yield put({
            type: 'save',
            payload: {
              rewardHistoryList: newList,
              rewardHistoryTotalCount: parseInt(response.totalCount, 10) || 0,
              rewardHistoryPageIndex: payload.pageIndex || 1,
            },
          });
          return response;
        }
        Toast.show({ icon: 'fail', content: resultMsg });
        return null;
      } catch (error) {
        Toast.show({ icon: 'fail', content: error.message || 'Error' });
        return null;
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
